import { Box, Button, TextField, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import Papa from "papaparse";
import './App.css';
import { getData3, getData4 } from './features/slices';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';


function ConvertImageFromSheet() {
  const [data, setData] = useState([]);
  const [option, setOption] = useState();
  const dispatch = useDispatch();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      Papa.parse(text, {
        header: false,
        skipEmptyLines: true,
        complete: function (results) {
          const csvData = results.data;
          const columnAData = csvData
            .filter((row) => row[0] !== undefined && row[0] !== "")
            .map((row) => row[0]);
          setData(columnAData);
        },
      });
    };
    reader.readAsText(file);
  };


  const handleConvert = async () => {
    if (option) {
      const res = await dispatch(getData3({ box: data, bucket: option }));
      const ws = XLSX.utils.aoa_to_sheet(res.payload);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `export_image${moment.unix()}.csv`);
    }
  }


  const handleConvert2 = async () => {
    if (option) {
      const res = await dispatch(getData4({ box: data, bucket: option }));
      const ws = XLSX.utils.aoa_to_sheet(res.payload);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `export_image${moment.unix()}.csv`);
    }
  }

  return (
    <Box sx={{ width: '100%' }}>
      <NotificationContainer />
      
      <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
          Upload CSV File
        </Typography>
        <Button
          variant="outlined"
          component="label"
          sx={{ mb: 2 }}
        >
          Chọn File CSV
          <input
            type="file"
            hidden
            onChange={handleFileUpload}
            accept=".csv"
          />
        </Button>
      </Paper>

      <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
          Cấu hình
        </Typography>
        <TextField
          label="Spaces Bucket name"
          fullWidth
          value={option}
          onChange={(e) => setOption(e.target.value)}
          placeholder="Nhập tên bucket"
          sx={{ mb: 3 }}
        />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button 
            variant="contained" 
            onClick={() => handleConvert()}
            size="large"
            sx={{ flex: 1 }}
          >
            Convert To Cloudinary
          </Button>
          <Button 
            variant="contained" 
            onClick={() => handleConvert2()}
            size="large"
            sx={{ flex: 1 }}
          >
            Convert To Spaces
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
export default ConvertImageFromSheet